import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useContext } from 'react';
import AppContext from '../../context';

import SuperAdminLogin from './Login';
import SuperAdminPortal from './Portal';

function SuperAdminRouter() {
	const context = useContext(AppContext);

	return (
		<BrowserRouter>
			<Routes>
				<Route
					path="/super-admin/login"
					element={context.user?.superAdmin ? <Navigate to="/super-admin/dashboard" /> : <SuperAdminLogin />}
				/>
				<Route
					path="/super-admin"
					element={context.user?.superAdmin ? <Navigate to="/super-admin/dashboard" /> : <Navigate to="/super-admin/login" />}
				/>
				<Route
					path="/super-admin/dashboard"
					element={context.user?.superAdmin ? <SuperAdminPortal page="dashboard" /> : <Navigate to="/super-admin/login" />}
				/>
				<Route
					path="/super-admin/customers"
					element={context.user?.superAdmin ? <SuperAdminPortal page="customers" /> : <Navigate to="/super-admin/login" />}
				/>
				<Route
					path="/super-admin/customers/:id"
					element={context.user?.superAdmin ? <SuperAdminPortal page="customer-view" /> : <Navigate to="/super-admin/login" />}
				/>
				<Route
					path="/super-admin/domains"
					element={context.user?.superAdmin ? <SuperAdminPortal page="domains" /> : <Navigate to="/super-admin/login" />}
				/>
				<Route
					path="/super-admin/domains/:id"
					element={context.user?.superAdmin ? <SuperAdminPortal page="domain-view" /> : <Navigate to="/super-admin/login" />}
				/>
				<Route
					path="/super-admin/domains/:id/users"
					element={context.user?.superAdmin ? <SuperAdminPortal page="domain-users" /> : <Navigate to="/super-admin/login" />}
				/>
				<Route
					path="/super-admin/*"
					element={<Navigate to={context.user?.superAdmin ? "/super-admin/dashboard" : "/super-admin/login"} />}
				/>
				<Route path="*" element={<Navigate to={context.user?.superAdmin ? "/super-admin/dashboard" : "/super-admin/login"} />} />
			</Routes>
		</BrowserRouter>
	);
}

export default SuperAdminRouter;
